import React, { Fragment, useContext, useEffect, useState } from "react"
import { AppContext } from "../../../context/createContext"
import WinNotificationEach from "./WinNotificationEach"
import { WinNotificationContainer } from "./WinNotificationStyles"
import { WinNotificationProps, moveProps } from "./winNotificationHelpers"
import jackpotWinnerSFX from "../../../lib/audio/jackpot_win_outer.mp3"

import JackpotWin from "./JackpotWin"
import useSound from "use-sound"

let timer: any
let timerTwo: any

const WinNotification = ({ isLoading }: any) => {
  const {
    roundUserUpdate,
    userupdate,
    auth: { player_id },
    notification,
    appFuncs: { resetRoundUserUpdate },
    jackpotState: { state },
    jackpot,
    audio: { sound, isSoundOff },
    jackpotInfo,
    config,
  } = useContext(AppContext)

  const [userCash, setUserCash] = useState<WinNotificationProps[]>([])
  const [jackpotInfoData, setjackpotWinData] = useState<any>(jackpotInfo)
  const [winnername, setWinnername] = useState<any>()
  const [move, setMove] = useState<moveProps>({
    moveOne: false,
    moveTwo: true,
  })

  const [playJackpotWinnerSFX, { stop: stopJackpotWinner }] = useSound(
    jackpotWinnerSFX,
    {
      volume: parseFloat(sound) / 100,
      soundEnabled: !isSoundOff,
    },
  )

  const adjustAnimation = (firt: boolean, second: boolean) => {
    setMove({
      moveOne: firt,
      moveTwo: second,
    })
  }

  const empty = {
    wintype: 0,
    winnername: "",
  }

  const clearUser = () => setTimeout(() => setUserCash([]), 3300)
  const setClearJackpot = () => setTimeout(() => setjackpotWinData(empty), 3000)

  const setUser = (roundUserUpdate: any) =>
    setUserCash(prevCon => [...prevCon, roundUserUpdate])

  const clearAimation = () =>
    setTimeout(() => adjustAnimation(false, false), 3000)

  useEffect(() => {
    if (player_id === roundUserUpdate.id) {
      if (roundUserUpdate.index == "0" && roundUserUpdate.cashout !== 0) {
        clearTimeout(timer)
        clearTimeout(timerTwo)
        adjustAnimation(true, true)
        setUser(roundUserUpdate)
        timer = clearAimation()
        timerTwo = clearUser()
      } else if (
        roundUserUpdate.index == "1" &&
        roundUserUpdate.cashout !== 0
      ) {
        clearTimeout(timer)
        clearTimeout(timerTwo)
        adjustAnimation(true, true)
        setUser(roundUserUpdate)
        timer = clearAimation()
        timerTwo = clearUser()
      }
    }
  }, [roundUserUpdate])

  useEffect(() => {
    if (userupdate.state === 3) {
      clearAimation()
      clearUser()
    }
  }, [userupdate])

  useEffect(() => {
    if (notification) {
      setUserCash([])
      adjustAnimation(false, false)
    }
  }, [notification])

  useEffect(() => {
    if (state === "initJackpot") {
      resetRoundUserUpdate()
    }
  }, [state])

  useEffect(() => {
    const winnerName = jackpotInfoData.winnername
    if (!isLoading && winnerName !== "") {
      setWinnername(winnerName)
      jackpotInfoData.winnername !== winnername && playJackpotWinnerSFX()
    }
  }, [isLoading, jackpotInfoData])

  useEffect(() => {
    if (jackpotInfo.wintype !== 0) {
      setjackpotWinData(jackpotInfo)
      setClearJackpot()
    }
  }, [jackpotInfo])

  return (
    <Fragment>
      {userCash.length !== 0 ? (
        <WinNotificationContainer>
          {userCash.map((winEach, i) => (
            <WinNotificationEach
              key={i}
              data={winEach}
              length={userCash.length}
              which={i}
              move={move}
              prec={config.prec}
            />
          ))}
        </WinNotificationContainer>
      ) : jackpotInfoData.wintype !== 0 && jackpotInfoData.winnerid ? (
        <WinNotificationContainer>
          <JackpotWin jackpotInfo={jackpotInfoData} />
        </WinNotificationContainer>
      ) : (
        <></>
      )}
    </Fragment>
  )
}

export default WinNotification
